import React from 'react';
import { CloseCircleFilled } from '@ant-design/icons';

interface Props {
  /** 当前选中的展示文案，未选择时为空 */
  value?: string;
  /** 占位文案 */
  placeholder?: string;
  /** 点击字段打开选择器 */
  onClick: () => void;
  /** 清除当前选择 */
  onClear?: () => void;
  /** 禁用 */
  disabled?: boolean;
}

/**
 * 下拉选择器的"入口"样式字段
 * 外观与 antd Select(single) 保持一致：右侧小箭头、占位符颜色；
 * 已选中状态下会展示清除图标。
 */
const PickerField: React.FC<Props> = ({
  value,
  placeholder = '请选择',
  onClick,
  onClear,
  disabled,
}) => {
  const hasValue = !!value;
  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={() => {
        if (!disabled) onClick();
      }}
      onKeyDown={e => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
      className={[
        'group relative flex h-8 w-full cursor-pointer items-center',
        'rounded-md border border-[#d9d9d9] bg-white pl-[11px] pr-7',
        'text-sm leading-none transition-colors',
        'hover:border-[#2094f0]',
        disabled ? 'cursor-not-allowed bg-[#f5f5f5] opacity-70' : '',
      ].join(' ')}
    >
      <span
        className={[
          'truncate',
          hasValue ? 'text-[#111827]' : 'text-[#bfbfbf]',
        ].join(' ')}
        title={value || placeholder}
      >
        {hasValue ? value : placeholder}
      </span>

      {/* 右侧：有值时展示清除图标；无值时展示下拉箭头 */}
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-[#bfbfbf]">
        {hasValue && onClear ? (
          <CloseCircleFilled
            className="pointer-events-auto cursor-pointer text-xs text-[#bfbfbf] hover:text-[#8c8c8c]"
            onClick={e => {
              e.stopPropagation();
              onClear();
            }}
          />
        ) : (
          <svg
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M1 1L5 5L9 1"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </div>
  );
};

export default PickerField;
